import axios from "axios";

const rawBase = (process.env.REACT_APP_API_URL || "").trim();

const normalizeBase = (value) => {
	const noTrailingSlash = value.replace(/\/+$/, "");
	if (noTrailingSlash.endsWith("/api")) return noTrailingSlash;
	return `${noTrailingSlash}/api`;
};

const BASE = normalizeBase(rawBase || "http://localhost:5000/api");

/* ── Games ── */
export const fetchAllGames    = ()   => axios.get(`${BASE}/games`).then((r) => r.data);
export const fetchTrendingGames = () => axios.get(`${BASE}/games/trending`).then((r) => r.data);
export const fetchFeaturedGames = () => axios.get(`${BASE}/games/featured`).then((r) => r.data);
export const fetchGameById    = (id) => axios.get(`${BASE}/games/${id}`).then((r) => r.data);
export const createGame       = (data) => axios.post(`${BASE}/games`, data).then((r) => r.data);
export const updateGame       = (id, data) => axios.put(`${BASE}/games/${id}`, data).then((r) => r.data);
export const deleteGame       = (id) => axios.delete(`${BASE}/games/${id}`).then((r) => r.data);

/* ── Newsletter ── */
export const subscribe = (email) => axios.post(`${BASE}/newsletter`, { email }).then((r) => r.data);
